import { filter, isEmpty, isNull, last, map } from 'lodash/fp';
// @ts-expect-error - Automatic, Please fix when editing this file
import getEligibleRewards from '@ahmdigital/offers/lib/model/offer/get-eligible-rewards';
// @ts-expect-error - Automatic, Please fix when editing this file
import getUpsellApplicableRewards from '@ahmdigital/offers/lib/model/offer/get-upsell-applicable-rewards';
// @ts-expect-error - Automatic, Please fix when editing this file
import isOfferEligible from '@ahmdigital/offers/lib/model/offer/is-eligible';

import generatePresaleSentence from '../utils/generate-presale-sentence';
import ProductPropType from '../../../../types/product';
import useGetActivePromoOffer from '../../logic/use-get-active-promo-offer';
import type { Offer, OfferPresaleText, OfferRewards } from '../../types';

type OfferWithPresaleDetails = {
  offer: Offer;
  presaleSentence: OfferPresaleText;
  rewards: OfferRewards;
};

type GetOfferPresaleDetails = {
  referrerAttribution?: string;
  scenario: {
    product: Partial<ProductPropType>;
    scale: string;
  };
  targetSegment?: string;
};
const useGetOfferPresaleDetails = ({ referrerAttribution, scenario, targetSegment }: GetOfferPresaleDetails) => {
  const { activeOffers: offers }: { activeOffers: Offer[] } = useGetActivePromoOffer({
    // @ts-expect-error - Automatic, Please fix when editing this file
    referrerAttribution,
    targetSegment,
  });

  if (isNull(offers)) {
    return null;
  }
  const scenarioForRewardEligibility = { ...scenario, productId: scenario?.product?.id };

  const getRewards = (offer: Offer): OfferRewards => {
    const eligibleRewards = getEligibleRewards(offer, scenarioForRewardEligibility);
    const upsellApplicableRewards = getUpsellApplicableRewards(offer, scenarioForRewardEligibility);
    return isEmpty(eligibleRewards) ? upsellApplicableRewards : eligibleRewards;
  };

  // @ts-expect-error - Automatic, Please fix when editing this file
  const offersWithPresaleDetails: OfferWithPresaleDetails[] = map((offer: Offer) => ({
    offer,
    presaleSentence: generatePresaleSentence(offer, scenario),
    rewards: getRewards(offer),
  }))(offers);

  const eligibleOffers = filter(({ offer }: OfferWithPresaleDetails) =>
    isOfferEligible(offer, scenarioForRewardEligibility),
  )(offersWithPresaleDetails);

  const filteredOffer = isEmpty(eligibleOffers)
    ? last(filter(({ rewards }: OfferWithPresaleDetails) => !isEmpty(rewards))(offersWithPresaleDetails))
    : last(eligibleOffers);

  if (!filteredOffer) {
    return null;
  }

  return filteredOffer;
};

export default useGetOfferPresaleDetails;
